import { FC } from 'react';
import { PageWrapper } from '@/components/ui';

export const InternalDashboardSkeleton: FC = () => (
    <PageWrapper title="Analytics" hideHeader containerClassName="p-0 bg-neutral-50 min-h-screen">
        <div className="p-6">
            <div className="animate-pulse space-y-4">
                <div className="h-12 bg-white border border-neutral-200/60" />
                <div className="grid grid-cols-5 gap-3">
                    {[...Array(5)].map((_, i) => <div key={i} className="h-20 bg-white border border-neutral-200/60" />)}
                </div>
                <div className="grid grid-cols-3 gap-3">
                    {[...Array(3)].map((_, i) => <div key={i} className="h-64 bg-white border border-neutral-200/60" />)}
                </div>
            </div>
        </div>
    </PageWrapper>
);
